import React, { useEffect, useMemo, useState } from "react";
import { useLanguage } from "../Translations/LenguageContext";
import { useNavigate, useParams } from "react-router-dom";
import { BiPlus } from "react-icons/bi";
import { TbInfoSquare, TbReload } from "react-icons/tb";
import NewContextModal from "./NewContextModal";
import ItemsLoader from "../Loaders/ItemsLoading";
import { GrAscend, GrDescend } from "react-icons/gr";
import { PiMagnifyingGlass } from "react-icons/pi";
import DeleteItemModal from "../Components/DeleteItemModal";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const Context = ({
    account_id,
    userData,
    singleOrgData,
    loadingSingleOrg,
    fetchSingleOrganization
}) => {
    const { t } = useLanguage()
    const { org_id } = useParams()
    const navigate = useNavigate()
    const [openModal, setOpenModal] = useState(false)
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [openDeleteItem, setOpenDeleteItem] = useState(false)
    const [selectedItem, setSelectedItem] = useState({})

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_contexts`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    limit: 20,
                    account_id,
                    org_id
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch");
            }

            setData(result.data || []);
        } catch (err) {
            console.error("Error fetching models:", err);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    useEffect(() => {
        fetchData();
    }, [account_id, org_id]);

    const filteredAndSortedData = useMemo(() => {
        if (!data) return [];

        let result = data.filter((item) => {
            const term = searchTerm.toLowerCase();
            const nameMatch = item.name?.toLowerCase().includes(term);
            const descMatch = item.description?.toLowerCase().includes(term);
            const permission = item.permission?.toLowerCase().includes(term);

            return nameMatch || descMatch || permission;
        });

        result.sort((a, b) => {
            const nameA = a.name?.toLowerCase() || "";
            const nameB = b.name?.toLowerCase() || "";
            if (sortOrder === "asc") {
                return nameA.localeCompare(nameB);
            } else {
                return nameB.localeCompare(nameA);
            }
        });

        return result;
    }, [data, searchTerm, sortOrder]);

    if (loading) {
        return <ItemsLoader />;
    }

    return (
        <div className="mainframe_item" >
            <div className="mainframe_item_header" >
                <p className="mainframe_item_title fade-in">{t.context.title}</p>
                <div className="mainframe_item_subtitle fade-in">
                    {data.length === 0 ? (
                        <div className="empty_org_mex_cont">
                            <p>
                                {t.context.empty_subtitle}
                            </p>
                            <div className="empty_org_img">
                                <p className="empty_org_img_title">
                                    <i><TbInfoSquare /></i> {t.context.quest_title}
                                </p>
                                <p className="empty_org_img_subtitle">
                                    {t.context.quest_answ}
                                </p>
                            </div>
                        </div>
                    ) : (
                        <p>
                            {t.context.subtitle}
                        </p>
                    )}
                </div>
                <button
                    className={`mainframe_item_create_btn fade-in ${data.length === 0 && "mainframe_item_create_btn_anim"}`}
                    onClick={() => setOpenModal(true)}
                >
                    <BiPlus /> {t.create}
                </button>
            </div>

            {(data.length > 0 || searchTerm) && (
                <div className="filter_body_mainframe">
                    <div className="filtering_mainframe">
                        <div className="filtering_mainframe_btn_cont fade-in">
                            {data.length > 1 && (
                                <>
                                    <button
                                        className={`filter_btn ${sortOrder === "asc" ? "active" : ""}`}
                                        onClick={() => setSortOrder("asc")}
                                        title="A-Z"
                                    >
                                        <GrAscend />
                                    </button>
                                    <button
                                        className={`filter_btn ${sortOrder === "desc" ? "active" : ""}`}
                                        onClick={() => setSortOrder("desc")}
                                        title="Z-A"
                                    >
                                        <GrDescend />
                                    </button>
                                </>
                            )}
                            <button
                                className="filter_btn"
                                onClick={() => fetchData()}
                                title={t.reload}
                            >
                                <TbReload />
                            </button>
                        </div>
                        <div className="filter_input_cont fade-in">
                            <input
                                className="filter_input"
                                placeholder={t.search_filter}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <span className="filter_input_icon"><PiMagnifyingGlass /></span>
                        </div>
                    </div>

                    <div className="organizations_cont">
                        {filteredAndSortedData.length > 0 ? (
                            <div className="organizations_cont_inner">
                                {filteredAndSortedData.map((item) => (
                                    <div
                                        key={item.id}
                                        className="organizations_item fade-in"
                                        onClick={() => navigate(item.id)}
                                    >
                                        <p className="organizations_item_title" title={item.name}>
                                            {item.name}
                                        </p>

                                        <p className="organizations_item_desc" title={item.description}>
                                            {item.description}
                                        </p>

                                        <div className="organizations_item_footer">
                                            <div></div>

                                            {/* <button
                                                type="button"
                                                className="delete_btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setOpenDeleteItem(true);
                                                    setSelectedItem(item);
                                                }}
                                            >
                                                <LuTrash2 />
                                            </button> */}
                                            <button className="open_btn">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </button>
                                            
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="organizations_cont_no_items_mex fade-in">
                                <p>{t.no_data_found_by_search}</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            <NewContextModal
                account_id={account_id}
                show={openModal}
                handleClose={() => setOpenModal(false)}
                fetchRecords={fetchData}
                userData={userData}
            />

            <DeleteItemModal
                account_id={account_id}
                show={openDeleteItem}
                handleClose={() => setOpenDeleteItem(false)}
                fetchRecords={fetchData}
                item={selectedItem}
                endpoint={"delete_context"}
                title={t.context.delete_title}
                description={t.context.delete_desc}
                input_value={selectedItem}
            />
        </div>
    )
}

export default Context